// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_3GL8NE","small":"_3gNniv","white":"_15X96O","path":"_1J5yNe","circular":"_26RoZr","rotate":"_3fvAD1","dash":"_1uVvs7","color":"_18bu8N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner/spinner-style.css
// module id = 255
// module chunks = 0